const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

const shortMonths = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'July',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];

const daysOfWeek = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
];

const eventTriggers = {
    SEND_NOTIFICATIONS: 'SendNotifications',
    INVOICE: 'Invoice',
    CHARGE: 'Charge',
    LOYALTY_CARDS: 'LoyaltyCards',
}

export {
    daysOfWeek,
    months,
    shortMonths,
    eventTriggers,
};
